/* =========================================================
   HAYBOX DE · Shopify-Theme
   Eine Datei fuer alle Seiten. Daten kommen aus dem Liquid-HTML
   (data-Attribute, JSON-Bloecke) und aus der Shopify-Ajax-API.
   GSAP, ScrollTrigger und Lenis liegen als Theme-Assets bei. Fehlen
   sie, laeuft der Shop ohne Animation (Klasse no-motion).
   ========================================================= */
(function () {
  'use strict';

  var d = document, w = window, body = d.body, root = d.documentElement;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var HB = w.HB || { routes: {}, t: {} };
  var T = HB.t || {};
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var gsap = w.gsap, ST = w.ScrollTrigger;
  var motion = !!(gsap && ST) && !reduce;
  var tpl = body.dataset.template;
  if (!motion) root.classList.add('no-motion');

  /* Preise im Format des Shops (Einstellungen > Waehrung), damit sie zu Liquid passen */
  var fmt = function (cents) {
    var f = HB.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'), comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return dot + ',' + parts[1];
      if (k === 'amount_no_decimals_with_comma_separator') return dot;
      if (k === 'amount_no_decimals') return comma;
      if (k === 'amount_with_apostrophe_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1];
      return comma + '.' + parts[1];
    }).replace(/<[^>]*>/g, '');
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toast.t); toast.t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* =======================================================
     Weiches Scrollen
     ======================================================= */
  var lenis = null, velocity = 0;
  if (motion) {
    gsap.registerPlugin(ST);
    ST.config({ ignoreMobileResize: true });
    if (w.Lenis && HB.smooth !== false) {
      lenis = new w.Lenis({ duration: 1.1, smoothWheel: true });
      lenis.on('scroll', function (e) { velocity = e.velocity || 0; ST.update(); });
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
      root.style.scrollBehavior = 'auto';
      new MutationObserver(function () {
        var lock = body.classList.contains('cart-open') || body.classList.contains('menu-open') || body.classList.contains('sheet-open');
        if (lock) lenis.stop(); else lenis.start();
      }).observe(body, { attributes: true, attributeFilter: ['class'] });
    }
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href'); if (id.length < 2) return;
    var el; try { el = $(id); } catch (x) { return; }
    if (!el) return;
    e.preventDefault();
    if (lenis) lenis.scrollTo(el, { offset: -80, duration: 1.2 }); else el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  });

  /* =======================================================
     Hinweisleiste, Kopf, Menue, Mega-Menue, Suche
     ======================================================= */
  (function announce() {
    var items = $$('#announce li'), i = 0;
    if (items.length < 2 || reduce) return;
    setInterval(function () {
      if (w.innerWidth >= 960 || d.hidden) return;
      items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on');
    }, 4000);
  }());

  var head = $('#head');
  (function header() {
    if (!head) return;
    var last = 0, prog = $('#progress');
    function on() {
      var y = w.scrollY, max = root.scrollHeight - w.innerHeight;
      head.classList.toggle('scrolled', y > 8);
      if (prog) prog.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      var busy = body.classList.contains('menu-open') || ($('#search') && !$('#search').hidden) || ($('#mega') && !$('#mega').hidden);
      if (!busy) head.classList.toggle('hide', y > last && y > 500);
      last = y;
    }
    w.addEventListener('scroll', on, { passive: true }); on();
  }());

  var burger = $('#burger'), drawer = $('#drawer');
  function setMenu(open) {
    if (!drawer) return;
    if (open) drawer.style.top = Math.max(0, head.getBoundingClientRect().bottom) + 'px';
    drawer.hidden = !open;
    burger.setAttribute('aria-expanded', open);
    $('use', burger).setAttribute('href', open ? '#i-close' : '#i-menu');
    body.classList.toggle('menu-open', open);
    if (open && motion) gsap.from($$('#drawer nav a'), { x: -30, opacity: 0, duration: .5, stagger: .04, ease: 'power3.out' });
  }
  if (burger) burger.addEventListener('click', function () { setMenu(drawer.hidden); });
  $$('#drawer a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });

  (function mega() {
    var m = $('#mega'), trig = $('.has-mega'), t;
    if (!m || !trig || !m.children.length) return;
    function open() { clearTimeout(t); m.hidden = false; }
    function close() { t = setTimeout(function () { m.hidden = true; }, 180); }
    trig.addEventListener('mouseenter', function () { if (fine) open(); });
    trig.addEventListener('mouseleave', close);
    m.addEventListener('mouseenter', open);
    m.addEventListener('mouseleave', close);
    trig.addEventListener('focus', open);
  }());

  (function search() {
    var box = $('#search'), inp = $('#searchInput'), res = $('#searchRes'), btn = $('#searchBtn'), timer, ctrl;
    if (!box) return;
    function render(products) {
      res.innerHTML = products.length ? products.map(function (p) {
        return '<li><a href="' + p.url + '">' + (p.image ? '<img class="wb" src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '') + esc(p.title) + '<span>' + (p.price_min ? T.from + ' ' + fmt(Math.round(parseFloat(p.price_min) * 100)) : '') + '</span></a></li>';
      }).join('') : '<li style="padding:1rem">' + esc(T.searchEmpty) + '</li>';
    }
    function query() {
      var q = inp.value.trim();
      if (q.length < 2) { res.innerHTML = ''; return; }
      if (ctrl) ctrl.abort(); ctrl = w.AbortController ? new AbortController() : null;
      fetch(HB.routes.search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) { render((j.resources && j.resources.results && j.resources.results.products) || []); })
        .catch(function () {});
    }
    btn.addEventListener('click', function () { box.hidden = !box.hidden; if (!box.hidden) inp.focus(); });
    $('#searchClose').addEventListener('click', function () { box.hidden = true; btn.focus(); });
    inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(query, 180); });
  }());

  /* =======================================================
     Warenkorb (Shopify Ajax API)
     ======================================================= */
  var Cart = (function () {
    var el = $('#cart'), scrim = $('#scrim'), state = null, lastFocus;
    if (!el) return { add: function () {}, total: function () { return 0; } };
    function render(c) {
      state = c;
      var n = c.item_count;
      var cnt = $('#cartCount');
      if (cnt) { cnt.textContent = n; cnt.classList.toggle('zero', !n); }
      el.classList.toggle('empty', !n);
      $('#cartItems').innerHTML = c.items.map(function (it) {
        var plan = it.selling_plan_allocation ? ' · ' + esc(it.selling_plan_allocation.selling_plan.name) : '';
        var variant = it.product_has_only_default_variant ? '' : esc(it.variant_title);
        return '<li class="line">' + (it.image ? '<img class="wb" src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="64" height="64">' : '<span></span>') +
          '<div><a href="' + it.url + '"><b>' + esc(it.product_title) + '</b></a><small>' + variant + plan + '</small>' +
          '<div class="qty"><button data-key="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="' + esc(T.qtyMinus) + '"><svg><use href="#i-minus"/></svg></button><span>' + it.quantity + '</span><button data-key="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="' + esc(T.qtyPlus) + '"><svg><use href="#i-plus"/></svg></button></div></div>' +
          '<span class="line__p">' + (it.final_line_price ? fmt(it.final_line_price) : esc(T.free)) + '</span></li>';
      }).join('');
      $('#cartSum').textContent = fmt(c.total_price);
      var left = Math.max(0, HB.freeShipping - c.total_price);
      $('#shipMsg').innerHTML = left > 0 ? T.freeLeft.replace('[amount]', fmt(left)) : T.freeDone;
      $('#shipBar').style.width = Math.min(100, c.total_price / HB.freeShipping * 100) + '%';
      d.dispatchEvent(new CustomEvent('cart:change', { detail: c }));
    }
    function load() { return fetch(HB.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }
    function open() {
      lastFocus = d.activeElement;
      el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); scrim.hidden = false;
      body.classList.add('cart-open');
      setTimeout(function () { $('#cartClose').focus(); }, 50);
    }
    function close() {
      el.classList.remove('open'); el.setAttribute('aria-hidden', 'true');
      if (!body.classList.contains('sheet-open')) scrim.hidden = true;
      body.classList.remove('cart-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function fly(from, done) {
      var target = $('#cartBtn');
      if (!from || !motion || !target) return done();
      head.classList.remove('hide');
      var r = from.getBoundingClientRect(), t = target.getBoundingClientRect();
      if (!r.width) return done();
      var s = Math.min(r.width, r.height, 140), f = d.createElement('img');
      f.src = from.currentSrc || from.src; f.className = 'flyer';
      f.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (r.left + r.width / 2 - s / 2) + 'px;top:' + (r.top + r.height / 2 - s / 2) + 'px';
      body.appendChild(f);
      var dx = t.left + t.width / 2 - (r.left + r.width / 2), dy = t.top + t.height / 2 - (r.top + r.height / 2);
      gsap.timeline({ onComplete: function () { f.remove(); done(); } })
        .to(f, { x: dx, duration: .7, ease: 'power1.inOut' }, 0)
        .to(f, { y: dy, duration: .7, ease: 'back.in(1.4)' }, 0)
        .to(f, { scale: .2, rotate: 300, duration: .7, ease: 'power2.in' }, 0);
    }
    /* item: { id, quantity, selling_plan } */
    function add(item, from, btn) {
      if (btn) btn.disabled = true;
      var req = fetch(HB.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
      var flown = new Promise(function (res) { fly(from, res); });
      return Promise.all([req, flown]).then(load).then(function () {
        var cnt = $('#cartCount'); if (cnt) { cnt.classList.remove('bump'); void cnt.offsetWidth; cnt.classList.add('bump'); }
        open();
      }).catch(function (err) {
        toast((err && (err.description || err.message)) || HB.t.error);
      }).then(function () { if (btn) btn.disabled = false; });
    }
    function change(key, q) {
      return fetch(HB.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) })
        .then(function (r) { return r.json(); }).then(render);
    }
    $('#cartItems').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-key]'); if (!b) return;
      b.disabled = true; change(b.dataset.key, +b.dataset.q);
    });
    var cb = $('#cartBtn');
    if (cb) cb.addEventListener('click', function (e) { e.preventDefault(); open(); });
    $('#cartClose').addEventListener('click', close);
    scrim.addEventListener('click', function () { close(); d.dispatchEvent(new CustomEvent('scrim')); });
    $$('[data-close]', el).forEach(function (a) { a.addEventListener('click', close); });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (el.classList.contains('open')) close();
      if (drawer && !drawer.hidden) setMenu(false);
      if ($('#search')) $('#search').hidden = true;
      if ($('#mega')) $('#mega').hidden = true;
      d.dispatchEvent(new CustomEvent('scrim'));
    });
    load();
    return { add: add, open: open, total: function () { return state ? state.total_price : 0; } };
  }());

  /* =======================================================
     Produktkarten: Groesse waehlen, in den Warenkorb
     ======================================================= */
  function hydrate(scope) {
    $$('.pc__media', scope).forEach(function (m) {
      var im = $('img.main', m), ok = function () { m.classList.add('loaded'); };
      if (!im || (im.complete && im.naturalWidth)) ok(); else { im.addEventListener('load', ok); im.addEventListener('error', ok); }
    });
    if (fine && !reduce) $$('.pc', scope).forEach(tilt);
    reveal(scope);
  }
  d.addEventListener('click', function (e) {
    var c = e.target.closest('.pc'); if (!c) return;
    var s = e.target.closest('.pc__sizes button');
    var add = $('.js-add', c);
    if (s) {
      $$('.pc__sizes button', c).forEach(function (b) { b.setAttribute('aria-checked', b === s); });
      $('.js-price', c).textContent = s.dataset.price;
      $('.js-unit', c).textContent = s.dataset.unit;
      if (add) { add.dataset.id = s.dataset.id; add.disabled = s.dataset.available !== 'true'; add.textContent = s.dataset.available === 'true' ? T.add : T.soldOut; }
      if (motion) gsap.fromTo($('.js-price', c), { y: -8, opacity: 0 }, { y: 0, opacity: 1, duration: .35 });
      return;
    }
    if (e.target.closest('.js-add')) Cart.add({ id: +add.dataset.id, quantity: 1 }, $('img.main', c), add);
  });

  /* Rails mit Ziehen, Pfeilen und Fortschritt */
  function rail(el) {
    if (el._rail) return el._rail;
    var box = el.closest('.tabpanel') || el.closest('section') || d;
    var bar = $('.rail__bar i', box), prev = $('[data-prev]', box), next = $('[data-next]', box);
    function prog() {
      var max = el.scrollWidth - el.clientWidth, vis = el.clientWidth / Math.max(1, el.scrollWidth);
      if (bar) { bar.style.width = Math.min(100, vis * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? el.scrollLeft / max * (1 / vis - 1) * 100 : 0) + '%)'; }
      if (prev) { prev.disabled = el.scrollLeft < 4; next.disabled = el.scrollLeft > max - 4; }
    }
    el.addEventListener('scroll', prog, { passive: true }); w.addEventListener('resize', prog);
    if (prev) {
      next.addEventListener('click', function () { el.scrollBy({ left: el.clientWidth * .8, behavior: 'smooth' }); });
      prev.addEventListener('click', function () { el.scrollBy({ left: -el.clientWidth * .8, behavior: 'smooth' }); });
    }
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.target.closest('button,a.btn')) return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
    w.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 6) { moved = true; el.classList.add('dragging'); } if (moved) el.scrollLeft = sl - dx; });
    w.addEventListener('pointerup', function () { if (down) { down = false; setTimeout(function () { el.classList.remove('dragging'); }, 0); } });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    prog();
    el._rail = prog;
    return prog;
  }
  $$('[data-rail]').forEach(rail);

  /* Tabs (Bestseller) */
  $$('[data-tabs]').forEach(function (tabs) {
    var sec = tabs.closest('section'), pill = $('.tabs__pill', tabs);
    function place() { var b = $('[aria-selected="true"]', tabs); if (b && pill) { pill.style.width = b.offsetWidth + 'px'; pill.style.transform = 'translateX(' + b.offsetLeft + 'px)'; } }
    $$('button[data-tab]', tabs).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button[data-tab]', tabs).forEach(function (x) { x.setAttribute('aria-selected', x === b); });
        $$('.tabpanel', sec).forEach(function (p) { p.hidden = p.id !== 'tab-' + b.dataset.tab; });
        var panel = $('#tab-' + b.dataset.tab);
        var r = $('[data-rail]', panel); if (r) { r.scrollLeft = 0; rail(r)(); }
        if (motion) gsap.from($$('.pc', panel), { y: 30, opacity: 0, duration: .6, stagger: .05, ease: 'power3.out' });
        place();
      });
    });
    w.addEventListener('resize', place); requestAnimationFrame(place);
  });

  /* =======================================================
     Bewegung: Kippen, Magnet, Ueberschriften, Einblenden
     ======================================================= */
  function tilt(el) {
    if (el._tilt) return; el._tilt = 1;
    el.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg) translateY(-4px)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }
  if (fine && !reduce) {
    $$('[data-tilt], .opt').forEach(tilt);
    $$('[data-magnetic]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * .2 + 'px,' + (e.clientY - r.top - r.height / 2) * .3 + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }
  function splitWords(el) {
    var out = [];
    (function walk(n) {
      Array.prototype.slice.call(n.childNodes).forEach(function (c) {
        if (c.nodeType === 1) return walk(c);
        if (c.nodeType !== 3) return;
        var frag = d.createDocumentFragment();
        c.textContent.split(/(\s+)/).forEach(function (t) {
          if (!t) return;
          if (/^\s+$/.test(t)) return frag.appendChild(d.createTextNode(' '));
          var o = d.createElement('span'), i = d.createElement('span');
          o.className = 'wd'; i.textContent = t; o.appendChild(i); frag.appendChild(o); out.push(i);
        });
        n.replaceChild(frag, c);
      });
    }(el));
    return out;
  }
  function lines(scope) {
    if (!motion) return;
    $$('[data-lines]', scope).forEach(function (h) {
      if (h._split) return; h._split = 1;
      gsap.from(splitWords(h), { yPercent: 115, rotate: 4, duration: 1, ease: 'expo.out', stagger: .05, scrollTrigger: { trigger: h, start: 'top 90%' } });
    });
  }
  var io = ('IntersectionObserver' in w) && !reduce ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -6% 0px' }) : null;
  function reveal(scope) {
    $$('.rv:not(.in)', scope).forEach(function (e, i) {
      if (!io) return e.classList.add('in');
      e.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(e);
    });
  }

  /* Kanten: Grashalme oder Welle am oberen Rand einer Sektion */
  (function edges() {
    function grass() {
      var n = 90, parts = [];
      for (var g = 0; g < 3; g++) {
        var dp = '';
        for (var i = g; i < n; i += 3) {
          var x = i / n * 1440 + (Math.sin(i * 7.3) * 6), h = 26 + ((Math.sin(i * 12.9) + 1) / 2) * 34, wd = 7 + (i % 4), lean = Math.sin(i * 3.1) * 12;
          dp += 'M' + (x - wd).toFixed(1) + ' 64 Q' + (x + lean * .3).toFixed(1) + ' ' + (64 - h * .6).toFixed(1) + ' ' + (x + lean).toFixed(1) + ' ' + (64 - h).toFixed(1) + ' Q' + (x + lean * .2 + 2).toFixed(1) + ' ' + (64 - h * .5).toFixed(1) + ' ' + (x + wd).toFixed(1) + ' 64Z';
        }
        parts.push('<path class="sway" d="' + dp + '"/>');
      }
      return '<svg viewBox="0 0 1440 64" preserveAspectRatio="none" aria-hidden="true"><g class="blades" fill="currentColor">' + parts.join('') + '<rect x="0" y="58" width="1440" height="7"/></g></svg>';
    }
    var wave = '<svg viewBox="0 0 1440 64" preserveAspectRatio="none" aria-hidden="true"><path fill="currentColor" d="M0 40 C 180 8 360 8 540 30 S 900 64 1080 36 S 1320 6 1440 26 V64 H0Z"/></svg>';
    $$('[data-edge]').forEach(function (s) {
      if ($(':scope > .edge', s)) return;
      var e = d.createElement('div');
      e.className = 'edge edge--' + s.dataset.edge; e.setAttribute('aria-hidden', 'true');
      e.innerHTML = s.dataset.edge === 'grass' ? grass() : wave;
      s.insertBefore(e, s.firstChild);
      if (motion && s.dataset.edge === 'grass') gsap.fromTo($('.blades', e), { scaleY: .15 }, { scaleY: 1, ease: 'none', scrollTrigger: { trigger: s, start: 'top bottom', end: 'top 55%', scrub: true } });
      if (motion && s.dataset.edge === 'wave') gsap.fromTo($('svg', e), { scaleX: 1.25, x: '-8%' }, { scaleX: 1, x: '0%', ease: 'none', scrollTrigger: { trigger: s, start: 'top bottom', end: 'top 50%', scrub: true } });
    });
  }());

  /* Laufbaender (Baender, Kundenfotos), schneller beim Scrollen */
  (function marquees() {
    var tracks = $$('[data-marquee]');
    tracks.forEach(function (t) { t.innerHTML += t.innerHTML; t._x = 0; t._d = +(t.dataset.speed || 1); t.addEventListener('pointerenter', function () { t._hold = 1; }); t.addEventListener('pointerleave', function () { t._hold = 0; }); });
    if (reduce || !tracks.length) return;
    var vis = new Map(), mio = new IntersectionObserver(function (en) { en.forEach(function (e) { vis.set(e.target, e.isIntersecting); }); });
    tracks.forEach(function (t) { mio.observe(t); });
    (function loop() {
      requestAnimationFrame(loop);
      var boost = Math.min(10, Math.abs(velocity) * .3);
      tracks.forEach(function (t) {
        if (vis.get(t) === false || t._hold) return;
        var half = t.scrollWidth / 2;
        t._x -= (.5 + boost) * t._d;
        if (t._x <= -half) t._x += half; if (t._x > 0) t._x -= half;
        t.style.transform = 'translate3d(' + t._x.toFixed(1) + 'px,0,0)';
      });
    }());
  }());

  /* FAQ und Akkordeons: weich auf und zu */
  if (motion) $$('.faq details, .acc details').forEach(function (det) {
    var box = $(':scope > div', det); if (!box) return;
    $('summary', det).addEventListener('click', function (e) {
      e.preventDefault();
      if (det.open) gsap.to(box, { height: 0, duration: .4, ease: 'power3.inOut', onComplete: function () { det.open = false; box.style.height = ''; ST.refresh(); } });
      else { det.open = true; gsap.fromTo(box, { height: 0 }, { height: 'auto', duration: .5, ease: 'power3.out', onComplete: function () { ST.refresh(); } }); }
    });
  });

  /* Heu-Explosion */
  function burst(host, n) {
    if (!motion || !host) return;
    for (var i = 0; i < n; i++) {
      var s = d.createElement('i'); s.className = 'straw'; s.style.height = (26 + Math.random() * 50) + 'px'; host.appendChild(s);
      var a = (Math.random() * 160 + 190) * Math.PI / 180, dist = 110 + Math.random() * 200;
      gsap.fromTo(s, { x: 0, y: 0, rotate: Math.random() * 360, opacity: 1 }, { x: Math.cos(a) * dist, y: Math.sin(a) * dist, rotate: '+=' + (Math.random() * 500 - 250), duration: 1.2 + Math.random() * .5, ease: 'expo.out',
        onComplete: (function (s) { return function () { gsap.to(s, { y: '+=60', opacity: 0, duration: .7, onComplete: function () { s.remove(); } }); }; }(s)) });
    }
  }

  /* Heuhalme auf Canvas (Hero) */
  function hayCanvas(cv) {
    if (!cv || !motion) return;
    var ctx = cv.getContext('2d'), dpr = Math.min(2, w.devicePixelRatio || 1), W, H, S = [], m = { x: -999, y: -999 }, vis = true, t = 0;
    var cols = ['0,145,119', '6,61,51', '212,234,124'];
    function mk(any) { return { x: Math.random() * W, y: any ? Math.random() * H : -30, l: 12 + Math.random() * 26, a: Math.random() * 6.3, va: (Math.random() - .5) * .02, vy: .2 + Math.random() * .45, vx: 0, b: (Math.random() - .5) * 12, c: cols[(Math.random() * 3) | 0], o: .18 + Math.random() * .28, p: Math.random() * 9 }; }
    function size() { var r = cv.getBoundingClientRect(); W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); S = []; for (var i = 0; i < Math.round(Math.min(28, W * H / 42000)); i++) S.push(mk(true)); }
    w.addEventListener('resize', size); size();
    cv.parentElement.addEventListener('pointermove', function (e) { var r = cv.getBoundingClientRect(); m.x = e.clientX - r.left; m.y = e.clientY - r.top; });
    cv.parentElement.addEventListener('pointerleave', function () { m.x = m.y = -999; });
    new IntersectionObserver(function (e) { vis = e[0].isIntersecting; }).observe(cv);
    (function loop() {
      requestAnimationFrame(loop); if (!vis) return; t += .016;
      ctx.clearRect(0, 0, W, H);
      var gust = Math.sin(t * .4) * .3 + Math.max(-30, Math.min(30, velocity)) * .01;
      S.forEach(function (s) {
        var dx = s.x - m.x, dy = s.y - m.y, dd = Math.sqrt(dx * dx + dy * dy);
        if (dd < 140) { var f = (1 - dd / 140) * 1.4; s.vx += dx / (dd || 1) * f; s.y += dy / (dd || 1) * f * .5; s.va += f * .01; }
        s.vx = s.vx * .94 + gust * .08; s.x += s.vx + Math.sin(t + s.p) * .2; s.y += s.vy; s.a += s.va; s.va *= .985;
        if (s.y > H + 30 || s.x < -50 || s.x > W + 50) Object.assign(s, mk(false));
        var c = Math.cos(s.a), n = Math.sin(s.a), h = s.l / 2;
        ctx.beginPath(); ctx.moveTo(s.x - c * h, s.y - n * h);
        ctx.quadraticCurveTo(s.x - n * s.b, s.y + c * s.b, s.x + c * h, s.y + n * h);
        ctx.strokeStyle = 'rgba(' + s.c + ',' + s.o + ')'; ctx.lineWidth = 1.4; ctx.lineCap = 'round'; ctx.stroke();
      });
    }());
  }

  /* =======================================================
     STARTSEITE
     ======================================================= */
  function home() {
    var hero = $('.hero--calm');
    if (hero) {
      // Hero + Vorteilsleiste fuellen den ersten Bildschirm (Desktop)
      var trust = $('.trust'), ann = $('.announce');
      var setFold = function () {
        hero.style.setProperty('--above', (ann ? ann.offsetHeight : 0) + (head ? head.offsetHeight : 0) + 'px');
        if (trust) hero.style.setProperty('--trust', trust.offsetHeight + 'px');
      };
      setFold(); w.addEventListener('resize', setFold); if (d.fonts) d.fonts.ready.then(setFold);

      // Tierwort wechselt von selbst
      var h1 = $('#heroH1'), word = $('#animalWord'), words = (h1.dataset.words || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean), wi = 0, hold = false;
      h1.addEventListener('pointerenter', function () { hold = true; });
      h1.addEventListener('pointerleave', function () { hold = false; });
      if (!reduce && words.length > 1) setInterval(function () {
        if (hold || d.hidden) return;
        wi = (wi + 1) % words.length;
        if (motion) gsap.to(word, { yPercent: -110, duration: .35, ease: 'power2.in', onComplete: function () { word.textContent = words[wi]; gsap.fromTo(word, { yPercent: 110 }, { yPercent: 0, duration: .7, ease: 'expo.out' }); } });
        else word.textContent = words[wi];
      }, 2800);

      var stage = $('#heroStage'), img = $('#heroImg'), media = $('#heroMedia');
      if (fine && motion && media) {
        media.addEventListener('pointermove', function (e) {
          var r = media.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          gsap.to(stage, { rotateY: x * 5, rotateX: -y * 5, transformPerspective: 1400, duration: .8, ease: 'power3.out' });
          gsap.to(img, { x: -x * 16, y: -y * 16, duration: 1, ease: 'power3.out' });
        });
        media.addEventListener('pointerleave', function () { gsap.to(stage, { rotateY: 0, rotateX: 0, duration: 1 }); gsap.to(img, { x: 0, y: 0, duration: 1 }); });
      }
      if (motion && img) gsap.fromTo(img, { scale: 1.06 }, { scale: 1.16, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      if (HB.hay) hayCanvas($('#hayCanvas'));
      if (motion) {
        gsap.timeline({ defaults: { ease: 'expo.out' } })
          .from(splitWords(h1), { yPercent: 115, rotate: 4, duration: 1.1, stagger: .07 }, .1)
          .from('.hero__copy > :not(h1)', { y: 22, opacity: 0, duration: .9, stagger: .08, ease: 'power3.out' }, .3)
          .from(stage, { clipPath: 'inset(8% 8% 8% 8% round 60px)', duration: 1.5 }, 0)
          .from('.spin-badge', { scale: 0, rotate: -160, duration: 1, ease: 'back.out(1.7)' }, .8);
        var badge = $('.spin-badge__txt');
        if (badge) gsap.ticker.add(function () { badge.style.animationDuration = Math.max(2.5, 18 - Math.abs(velocity) * 1.2) + 's'; });
      }
    }

    // Zaehler
    if (motion) $$('[data-count]').forEach(function (el) {
      var o = { v: 0 }, to = +el.dataset.count;
      gsap.to(o, { v: to, duration: 2, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 95%' }, onUpdate: function () { el.textContent = Math.round(o.v).toLocaleString('de-DE'); } });
    });

    // Kategorien: Bild folgt dem Cursor
    (function catpeek() {
      var peek = $('#catpeek'); if (!peek || !fine || reduce) return;
      var list = peek.previousElementSibling;
      if (motion && list) gsap.from($$('li', list), { y: 50, opacity: 0, duration: .9, stagger: .06, ease: 'expo.out', scrollTrigger: { trigger: list, start: 'top 85%' } });
      var imgs = $$('img', peek), cur = 0, x = 0, y = 0, tx = 0, ty = 0, rot = 0, lx = 0;
      $$('.catlist a').forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          var src = a.dataset.img; if (!src) return;
          if (imgs[cur].getAttribute('src') !== src) { imgs[1 - cur].src = src; imgs[1 - cur].style.opacity = 1; imgs[cur].style.opacity = 0; cur = 1 - cur; }
          peek.classList.add('show');
        });
        a.addEventListener('mouseleave', function () { peek.classList.remove('show'); });
      });
      w.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; }, { passive: true });
      (function loop() {
        requestAnimationFrame(loop);
        if (!peek.classList.contains('show')) return;
        x += (tx - x) * .12; y += (ty - y) * .12; rot += (Math.max(-14, Math.min(14, (tx - lx) * .6)) - rot) * .1; lx = x;
        peek.style.left = (x - 140) + 'px'; peek.style.top = (y - 175) + 'px'; peek.style.rotate = rot + 'deg';
      }());
    }());

    // Heu-Finder
    (function finder() {
      var data; try { data = JSON.parse(($('#finderData') || {}).textContent || '[]'); } catch (e) { data = []; }
      if (!data.length) return;
      var range = $('#texRange'), track = $('#texTrack'), im = $('#finderImg'), i = Math.min(1, data.length - 1), an = 'k';
      function layout() { track.style.setProperty('--tx', ((track.clientWidth - 56) * i / Math.max(1, data.length - 1)) + 'px'); }
      function render(anim) {
        var p = data[i];
        range.value = i; range.setAttribute('aria-valuetext', p.name);
        $$('#texNames button').forEach(function (b, j) { b.classList.toggle('on', j === i); });
        $('#finderName').textContent = p.title;
        $('#finderHint').textContent = p[an] || '';
        $('#finderTag').textContent = p.tag || '';
        $('#ringText').textContent = (p.title + ' · ').repeat(3);
        $('#finderStage').dataset.tint = p.tint || 'lime';
        $$('#meters i').forEach(function (m, j) { m.style.width = p.feel[j] * 20 + '%'; });
        $('#texThumb svg').style.transform = 'rotate(' + (i * 30 - 30) + 'deg)';
        $('#finderPrice').textContent = p.price + ' · ' + p.size;
        $('#finderUnit').textContent = (p.unit ? p.unit + ' · ' : '') + 'inkl. MwSt., zzgl. Versand';
        var add = $('#finderAdd'); add.disabled = !p.available;
        $('span', add).textContent = p.available ? T.add : T.soldOut;
        im.classList.toggle('wb', !!p.wb);
        layout();
        if (anim && motion) {
          gsap.timeline().to(im, { scale: .5, rotate: 40, opacity: 0, duration: .25, ease: 'power2.in' })
            .add(function () { im.src = p.img; im.alt = p.title; })
            .fromTo(im, { scale: .6, rotate: -45 }, { scale: 1, rotate: 0, opacity: 1, duration: .9, ease: 'elastic.out(1,.6)' });
        } else { im.src = p.img; im.alt = p.title; }
      }
      range.addEventListener('input', function () { if (+range.value !== i) { i = +range.value; render(true); } });
      $$('#texNames button').forEach(function (b) { b.addEventListener('click', function () { i = +b.dataset.i; render(true); }); });
      $$('.seg--animal button').forEach(function (b) {
        b.addEventListener('click', function () { an = b.dataset.animal; $$('.seg--animal button').forEach(function (x) { x.setAttribute('aria-checked', x === b); }); $('#finderHint').textContent = data[i][an] || ''; });
      });
      $('#finderAdd').addEventListener('click', function () { Cart.add({ id: data[i].variant, quantity: 1 }, im, this); });
      w.addEventListener('resize', layout);
      render(false);
    }());

    // Abo oder einmal
    (function plan() {
      var f = $('#planForm'); if (!f) return;
      var btn = $('#planAdd');
      function sync() { $('span', btn).textContent = f.plan.value === 'abo' ? T.addAbo : T.add; }
      f.addEventListener('change', sync);
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var abo = f.plan.value === 'abo';
        if (abo && f.dataset.hasPlans !== 'true') { w.location.href = f.dataset.productUrl; return; }
        var item = { id: +f.dataset.variant, quantity: 1 };
        if (abo && f.selling_plan) item.selling_plan = +f.selling_plan.value;
        Cart.add(item, null, btn);
      });
      sync();
    }());

    // So geht's
    (function how() {
      var el = $('#howSteps'); if (!el) return;
      if (!io) { el.classList.add('drawn'); el.style.setProperty('--p', 1); return; }
      var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { el.classList.add('drawn'); el.style.setProperty('--p', 1); o.disconnect(); } }, { threshold: .4 });
      o.observe(el);
    }());

    // Feldszene, Ring, Baender
    (function scenes() {
      var C = 2 * Math.PI * 86;
      function ring(p) {
        if (!$('#segA')) return;
        $('#segA').setAttribute('stroke-dasharray', Math.max(0, C * .85 * p - 16) + ' ' + C);
        $('#segB').setAttribute('stroke-dasharray', Math.max(0, C * .1 * Math.max(0, Math.min(1, p * 1.4 - .4)) - 16) + ' ' + C);
        $('#segB').setAttribute('stroke-dashoffset', -C * .85);
        $('#segC').setAttribute('stroke-dasharray', Math.max(0, C * .05 * Math.max(0, Math.min(1, p * 2 - 1)) - 14) + ' ' + C);
        $('#segC').setAttribute('stroke-dashoffset', -C * .95);
        $('#dietNum').textContent = Math.round(90 * p);
      }
      if (!motion) { ring(1); return; }
      if ($('.diet')) { ring(0); var o = { p: 0 }; gsap.to(o, { p: 1, ease: 'none', onUpdate: function () { ring(o.p); }, scrollTrigger: { trigger: '.diet', start: 'top 80%', end: 'center 50%', scrub: .6 } }); }
      if ($('.field')) gsap.timeline({ scrollTrigger: { trigger: '.field', start: 'top top', end: 'bottom bottom', scrub: .8 } })
        .fromTo('#fieldFrame', { clipPath: 'inset(28% 30% 28% 30% round 400px)' }, { clipPath: 'inset(0% 0% 0% 0% round 0px)', ease: 'power2.inOut', duration: 1 }, 0)
        .fromTo('#fieldFrame img', { scale: 1.3 }, { scale: 1, ease: 'power2.inOut', duration: 1 }, 0)
        .to('.field__shade', { opacity: 1, duration: .5 }, .5)
        .to('.field__words span', { opacity: 1, y: 0, stagger: .2, duration: .35, ease: 'power3.out' }, .6)
        .to({}, { duration: .3 });
      if ($('.ribbons')) {
        gsap.fromTo('.ribbon--teal', { rotate: -6 }, { rotate: -1.5, ease: 'none', scrollTrigger: { trigger: '.ribbons', start: 'top bottom', end: 'bottom top', scrub: true } });
        gsap.fromTo('.ribbon--lime', { rotate: 5 }, { rotate: 1, ease: 'none', scrollTrigger: { trigger: '.ribbons', start: 'top bottom', end: 'bottom top', scrub: true } });
      }
      $$('.why__item img').forEach(function (im) { gsap.fromTo(im, { yPercent: 4 }, { yPercent: -4, ease: 'none', scrollTrigger: { trigger: im, start: 'top bottom', end: 'bottom top', scrub: true } }); });
    }());

    var ta = $('#tasterAdd');
    if (ta) ta.addEventListener('click', function () { burst($('#burst'), 30); Cart.add({ id: +ta.dataset.id, quantity: 1 }, $('#tasterBox img'), ta); });
    var tb = $('#tasterBox');
    if (tb) tb.addEventListener('click', function () { burst($('#burst'), 26); });
  }

  /* =======================================================
     KATEGORIESEITE: Filter ohne Neuladen
     ======================================================= */
  function listing() {
    var form = $('#FilterForm'), plp = $('#plp'); if (!form || !plp) return;
    var F = $('#filters'), scrim = $('#scrim');
    function sheet(open) {
      F.classList.toggle('open', open); $('#filterOpen').setAttribute('aria-expanded', open);
      body.classList.toggle('sheet-open', open);
      scrim.hidden = !open && !body.classList.contains('cart-open');
    }
    var desktop = function () { return w.innerWidth >= 1000; };
    function load(url) {
      var main = $('#plpMain'); main.classList.add('is-loading');
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + plp.dataset.section;
      fetch(u).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('plp');
        if (!fresh) { w.location.href = url; return; }
        // Filterzaehler, Chips und Raster tauschen, offene Gruppen behalten
        $('.plp__chips', plp).innerHTML = $('.plp__chips', fresh).innerHTML;
        $('.filters__body', plp).innerHTML = $('.filters__body', fresh).innerHTML;
        $('#plpMain').innerHTML = $('#plpMain', fresh).innerHTML;
        var fb = $('#filterOpen'), nb = $('#filterOpen', fresh); if (fb && nb) fb.innerHTML = nb.innerHTML;
        hydrate($('#plpMain'));
        history.replaceState(null, '', url);
        if (motion) gsap.from($$('#pgrid > li'), { y: 24, opacity: 0, duration: .5, stagger: .03, ease: 'power3.out' });
      }).catch(function () { w.location.href = url; });
    }
    function submit() {
      var params = new URLSearchParams(new FormData(form));
      $$('input[type=number]', form).forEach(function (n) { if (!n.value) params.delete(n.name); });
      load(form.action + '?' + params.toString());
    }
    form.addEventListener('change', function (e) {
      if (e.target.id === 'SortBy' || desktop()) submit();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); if (!desktop()) sheet(false); });
    plp.addEventListener('click', function (e) {
      var a = e.target.closest('.chip-x, .pager a, .filters__foot a, .plp__empty a');
      if (!a) return;
      e.preventDefault(); load(a.href); if (!desktop()) sheet(false);
    });
    $('#filterOpen').addEventListener('click', function () { sheet(true); });
    $('#filterClose').addEventListener('click', function () { sheet(false); });
    d.addEventListener('scrim', function () { if (F.classList.contains('open')) sheet(false); });
    if (motion) {
      var h = $('.plp-hero__h1'); if (h) gsap.from(splitWords(h), { yPercent: 115, duration: 1, ease: 'expo.out', stagger: .06 });
      gsap.from('.plp-hero__img', { scale: .6, rotate: -10, opacity: 0, duration: 1.2, ease: 'expo.out' });
      gsap.from('.cattabs a', { y: 20, opacity: 0, duration: .6, stagger: .04, ease: 'power3.out', delay: .2 });
    }
    var ct = $('.cattabs [aria-current]'); if (ct) ct.scrollIntoView({ inline: 'center', block: 'nearest' });
  }

  /* =======================================================
     PRODUKTSEITE
     ======================================================= */
  function product() {
    var sec = $('#pdp'); if (!sec) return;
    var data; try { data = JSON.parse($(sec.dataset.productJson).textContent); } catch (e) { return; }
    var form = $('#ProductForm'), vid = $('#VariantId'), planInput = $('#SellingPlan');
    var v = data.variants.filter(function (x) { return x.id === +vid.value; })[0] || data.variants[0];
    var abo = !!planInput, planId = planInput ? +planInput.value : null;

    // Galerie
    var gt = $('#galTrack'), slides = $$('li', gt), gi = 0;
    if (slides.length > 1) {
      $('#galThumbs').innerHTML = slides.map(function (s, i) { var im = $('img', s); return '<li><button type="button" aria-label="' + HB.t.image + ' ' + (i + 1) + '" aria-current="' + !i + '"><img class="' + (im.className || '') + '" src="' + (im.currentSrc || im.src) + '" alt="" loading="lazy"></button></li>'; }).join('');
      $('#galDots').innerHTML = slides.map(function (_, i) { return '<i class="' + (i ? '' : 'on') + '"></i>'; }).join('');
    } else { $('#galPrev').hidden = true; $('#galNext').hidden = true; }
    function goSlide(i) { gi = Math.max(0, Math.min(slides.length - 1, i)); gt.scrollTo({ left: gi * gt.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    gt.addEventListener('scroll', function () {
      var i = Math.round(gt.scrollLeft / gt.clientWidth); if (i === gi && gt._init) return; gi = i; gt._init = 1;
      $$('#galThumbs button').forEach(function (b, j) { b.setAttribute('aria-current', j === i); });
      $$('#galDots i').forEach(function (b, j) { b.classList.toggle('on', j === i); });
    }, { passive: true });
    $('#galPrev').addEventListener('click', function () { goSlide(gi - 1); });
    $('#galNext').addEventListener('click', function () { goSlide(gi + 1); });
    $$('#galThumbs button').forEach(function (b, i) { b.addEventListener('click', function () { goSlide(i); }); });
    if (fine) slides.forEach(function (li) {
      var im = $('img', li);
      li.addEventListener('mousemove', function (e) { var r = li.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; im.style.transform = 'scale(1.8)'; });
      li.addEventListener('mouseleave', function () { im.style.transform = ''; });
    });

    var qInput = $('#qVal');
    function plan() { return v.plans.filter(function (p) { return p.id === planId; })[0] || v.plans[0]; }
    function update(anim) {
      vid.value = v.id;
      var pl = abo ? plan() : null;
      var price = pl ? pl.price : v.price;
      $('#pdpPrice').textContent = v.price ? fmt(price) : T.free;
      $('#pdpUnit').textContent = pl ? pl.unit : v.unit;
      if ($('#poAbo') && pl) $('#poAbo').innerHTML = '<s>' + v.price_f + '</s>' + pl.price_f;
      if ($('#poOnce')) $('#poOnce').textContent = v.price_f;
      if ($('#poInt')) $('#poInt').classList.toggle('off', !abo);
      if (planInput) { planInput.disabled = !abo; if (pl) planInput.value = pl.id; }
      var add = $('#pdpAdd');
      if (add) { add.disabled = !v.available; $('span', add).textContent = !v.available ? T.soldOut : (abo ? T.addAbo : (v.price ? T.add : T.free)); }
      var sb = $('#sbPrice'); if (sb) sb.textContent = fmt(price) + ' · ' + v.title.split('(')[0].trim() + (abo ? ' · Abo' : '');
      var sa = $('#sbAdd'); if (sa) { sa.textContent = add ? $('span', add).textContent : T.add; sa.disabled = !v.available; }
      var q = Math.max(1, +qInput.value || 1), left = HB.freeShipping - Cart.total() - price * q;
      var free = $('#pdpFree');
      if (free) free.innerHTML = !v.price ? '' : (left <= 0 ? T.freeDone : T.freeLeft.replace('[amount]', fmt(left)));
      if (anim && motion) gsap.fromTo('#pdpPrice', { y: -10, opacity: 0 }, { y: 0, opacity: 1, duration: .4 });
    }
    $$('#pdpSizes .size').forEach(function (b) {
      b.addEventListener('click', function () {
        v = data.variants.filter(function (x) { return x.id === +b.dataset.id; })[0];
        $$('#pdpSizes .size').forEach(function (x) { x.setAttribute('aria-checked', x === b); });
        var u = new URL(w.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
        update(true);
      });
    });
    $$('input[name=po]').forEach(function (r) { r.addEventListener('change', function () { abo = r.value === 'abo'; update(true); }); });
    $$('#poInt [data-plan]').forEach(function (b) {
      b.addEventListener('click', function () { planId = +b.dataset.plan; $$('#poInt [data-plan]').forEach(function (x) { x.setAttribute('aria-checked', x === b); }); update(true); });
    });
    if (qInput) {
      $('#qMinus').addEventListener('click', function () { qInput.value = Math.max(1, (+qInput.value || 1) - 1); update(); });
      $('#qPlus').addEventListener('click', function () { qInput.value = Math.min(+qInput.max || 20, (+qInput.value || 1) + 1); update(); });
      qInput.addEventListener('change', update);
    }
    function addNow(from) {
      var item = { id: v.id, quantity: Math.max(1, +qInput.value || 1) };
      if (abo && planInput) item.selling_plan = +planInput.value;
      Cart.add(item, from || $('#galTrack img'), $('#pdpAdd'));
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addNow(); });
    var sbBtn = $('#sbAdd'); if (sbBtn) sbBtn.addEventListener('click', function () { addNow($('#stickyBuy img')); });
    d.addEventListener('cart:change', function () { update(); });

    // Gefuehl
    setTimeout(function () { $$('.feel .meter__bar i').forEach(function (m) { m.style.width = m.dataset.w + '%'; }); }, 400);

    // Klebende Kaufleiste
    var sticky = $('#stickyBuy'), row = $('#buyRow');
    if (sticky && row) new IntersectionObserver(function (en) { var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', !show); }).observe(row);

    update();
    if (motion) {
      gsap.from('.gal__main', { clipPath: 'inset(8% 8% 8% 8% round 40px)', duration: 1.2, ease: 'expo.out' });
      var first = $('#galTrack li:first-child img'); if (first) { first.style.transition = 'none'; gsap.from(first, { scale: .6, rotate: -20, opacity: 0, duration: 1.2, ease: 'elastic.out(1,.7)', delay: .1, clearProps: 'transform,opacity', onComplete: function () { first.style.transition = ''; } }); }
      gsap.from(splitWords($('.buybox__h1')), { yPercent: 115, duration: 1, stagger: .05, ease: 'expo.out' });
    }
  }

  /* Empfehlungen nachladen (Shopify Recommendations API) */
  $$('[data-recs]').forEach(function (s) {
    fetch(s.dataset.recs).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var list = $('[data-recs-target]', doc), target = $('[data-recs-target]', s);
      if (list && list.children.length) { target.innerHTML = list.innerHTML; hydrate(target); rail($('[data-rail]', s))(); }
      if (!target.children.length) s.hidden = true;
    }).catch(function () {});
  });

  /* Konto: Passwort vergessen umschalten */
  $$('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); $('#LoginBox').hidden = !$('#LoginBox').hidden; $('#RecoverBox').hidden = !$('#RecoverBox').hidden; });
  });
  if (location.hash === '#recover' && $('#RecoverBox')) { $('#LoginBox').hidden = true; $('#RecoverBox').hidden = false; }
  $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });

  /* =======================================================
     Start
     ======================================================= */
  if (tpl === 'index') home();
  if (tpl === 'collection') listing();
  if (tpl === 'product') product();
  hydrate(d);
  $$('.why__item, .how__steps li, .faq details, .opt, .rev').forEach(function (e) { e.classList.add('rv'); });
  reveal(d);
  lines(d);
  if (motion) w.addEventListener('load', function () { ST.refresh(); });
}());

/* Land- und Sprachwahl: bei Klick daneben oder Escape schliessen */
document.addEventListener('click', function (e) {
  document.querySelectorAll('details.loc[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
});
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') document.querySelectorAll('details.loc[open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
});
